module.exports = __webpack_public_path__ + "img/bg-login-bl.36665325.png";